module.exports = __webpack_public_path__ + "img/logo.a34a460a.png";